import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import * as buttonStyles from '../Content/Button/Button.module.scss'
import * as styles from './NewsletterForm.module.scss'

type Inputs = {
	'cm-name': string
	'cm-xujtri-xujtri': string
}

const NewsletterForm: React.FunctionComponent = () => {
	const [loading, setLoading] = React.useState(false)
	const [wasSuccessful, setWasSuccessful] = React.useState(false)
	const [wasUnsuccessful, setWasUnsuccessful] = React.useState(false)

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<Inputs>()

	const onSubmit: SubmitHandler<Inputs> = async (data) => {
		setLoading(true)
		setWasSuccessful(false)
		setWasUnsuccessful(false)

		try {
			const response = await fetch('https://tankpr.createsend.com/t/j/s/xujtri/', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			})

			if (response.status === 200) {
				setWasSuccessful(true)
			} else {
				setWasUnsuccessful(true)
			}
		} catch (error) {
			setWasUnsuccessful(true)
		}

		setLoading(false)
	}

	const formStyles = [styles.form]

	return (
		<form className={formStyles.join(' ')} onSubmit={handleSubmit(onSubmit)}>
			<fieldset>
				<legend>Newsletter Signup</legend>
			</fieldset>

			<fieldset>
				<div className={styles.inputWrapper}>
					<input
						type="text"
						placeholder="Name"
						{...register('cm-name', { required: true, maxLength: 30 })}
						className={styles.input}
					/>
					{errors['cm-name'] && <span className={styles.error}>Name is required</span>}
				</div>

				<div className={styles.inputWrapper}>
					<input
						type="email"
						placeholder="Email"
						{...register('cm-xujtri-xujtri', { required: true, pattern: /^\S+@\S+$/i })}
						className={styles.input}
					/>
					{errors['cm-xujtri-xujtri'] && (
						<span className={styles.error}>
							{errors['cm-xujtri-xujtri'].type == 'required' && 'Email is required'}
							{errors['cm-xujtri-xujtri'].type == 'pattern' && 'Email is not valid'}
						</span>
					)}
				</div>
			</fieldset>

			<fieldset>
				<input type="submit" value="Subscribe" className={buttonStyles.button} />
			</fieldset>
		</form>
	)
}

export default NewsletterForm
